import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import {storeModule as auth} from '@/velta/components/auth';
import adminAssinaturas from './admin/assinaturas'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        appConfig,
        verticalMenu,
        auth,
        adminAssinaturas,
    },
    strict: false,
})
